import * as React from "react"
import Box from "@mui/material/Box"
import PropTypes from "prop-types"
import { Dialog, DialogContent, Typography, IconButton } from "@mui/material"
import { ReactComponent as CloseMenuIcon } from "src/v2/assets/icons/close-icon.svg"
import theme from "src/v2/theme/theme"

const GenericModal = ({ isOpen, onClose, title, children, width, fullWidth }) => {
    const modalWidth = width || "442px"
    return (
        <div>
            <Dialog
                open={isOpen}
                fullWidth={fullWidth ? fullWidth : false}
                maxWidth={false}
                sx={{
                    "& .MuiPaper-root": {
                        width: modalWidth,
                        borderRadius: "0px",
                    },
                    "& .MuiDialogContent-root": {
                        padding: "0px",
                        paddingBottom: "24px",
                    },
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        marginBottom: "24px",
                        px: "24px",
                        paddingTop: "24px",
                    }}
                >
                    <Typography variant="h3" color="common.white">
                        {title}
                    </Typography>
                    <IconButton
                        sx={{
                            color: "common.white",
                            "&:hover": {
                                backgroundColor: "rgba(255,255,255,0.1)",
                            },
                        }}
                        onClick={onClose}
                    >
                        <CloseMenuIcon
                            style={{ color: theme.palette.icon.main }}
                        />
                    </IconButton>
                </Box>
                <DialogContent
                    sx={{
                        flex: 1,
                        overflowY: "auto",
                        "&::-webkit-scrollbar": {
                            width: "16px",
                            background: "transparent",
                        },
                        "&::-webkit-scrollbar-thumb": {
                            backgroundColor: "#D9D9D9",
                            opacity: "40%",
                            borderRadius: "8px",
                            border: `5px solid transparent`,
                            backgroundClip: "padding-box",
                            marginBlockStart: "16px",
                        },
                        "&::-webkit-scrollbar-track": {
                            background: "transparent",
                        },
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                        }}
                    >
                        {children}
                    </Box>
                </DialogContent>
            </Dialog>
        </div>
    )
}

GenericModal.propTypes = {
    title: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    width: PropTypes.string,
    fullWidth: PropTypes.bool,
}

export default GenericModal
